.ka{border-radius:0.375rem;}